import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, GridItemTypeTokens, ImageSizeTokens, ResizeModeToken, SizeTypeTokens, TextAlignTokens, } from '@voltmoney/schema';
import React, { memo, useState } from 'react';
import { Dimensions, FlatList, Pressable, Text, View, StyleSheet, Platform } from 'react-native';
import { Space } from '../space/Space';
import Image from '../image/Image';
import Typography from '../typography/Typography';
import Divider from '../divider/Divider';
import ThemeProvider from '@voltmoney/theme';
import { Icon } from "../icon/Icon";
import { WebView } from 'react-native-webview';
import { isFromAndroidWebview } from "../pages/utils";
const GridListItem = ({ id, data, 
// numColumns = 4,
title, otherItem, other, type, action, triggerAction, imageSize, isIFrame, dashboardMenuItems, noOfCols, isMobile }) => {
    const theme = ThemeProvider.getTheme();
    const screenWidth = Dimensions.get('screen').width;
    let numColumns;
    if (screenWidth < 300) {
        // small screen
        numColumns = 3;
    }
    else if (screenWidth > 300 &&
        screenWidth < 601) {
        // mobile
        numColumns = 4;
    }
    else if (screenWidth > 601 &&
        screenWidth < 769) {
        //potriat mob
        numColumns = 5;
    }
    else {
        // large screen
        numColumns = 5;
    }
    let numColumnsX = numColumns;
    const handleAction = (value) => {
        action &&
            triggerAction &&
            triggerAction({
                ...action,
                payload: { ...action.payload, value },
            });
    };
    const handleDashboardAction = (index) => {
        triggerAction &&
            dashboardMenuItems &&
            dashboardMenuItems[index] &&
            dashboardMenuItems[index].action &&
            triggerAction(dashboardMenuItems[index].action);
    };
    const horizontalRenderItem = ({ item, index, }) => imageSize ? (React.createElement(React.Fragment, null,
        React.createElement(View, { nativeID: id + item.label, style: {
                flexDirection: 'row',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    paddingLeft: imageSize ? 0 : 2,
                } },
                React.createElement(View, { style: {
                        width: imageSize ? 330 : screenWidth > 400 ? 90 : 82,
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingHorizontal: imageSize ? 0 : 8,
                    } },
                    React.createElement(Image, { uri: item.image, defaultUri: item.defaultUri, size: ImageSizeTokens.MD, width: imageSize ? 330 : null, height: imageSize ? 364 : null, resizeMode: imageSize && ResizeModeToken.CONTAIN }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    item['label'] ? (React.createElement(Typography, { label: item['label'].length > 6
                            ? item['label'].substring(0, 8) + '..'
                            : item['label'].substring(0, 4) + '..', fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, numberOfLines: 1 })) : null,
                    React.createElement(Space, { size: SizeTypeTokens.XXL }))),
            imageSize ? React.createElement(Space, { size: SizeTypeTokens.XXXL }) : null))) : (React.createElement(React.Fragment, null,
        React.createElement(Pressable, { nativeID: id + '_' + item.label, style: {
                flexDirection: 'row',
            }, onPress: () => handleAction(item['label']) },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    paddingLeft: imageSize ? 0 : 2,
                } },
                React.createElement(View, { style: {
                        width: imageSize ? 330 : screenWidth > 400 ? 90 : 82,
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingHorizontal: imageSize ? 0 : 8,
                    } },
                    React.createElement(Image, { uri: item.image, defaultUri: item.defaultUri, size: ImageSizeTokens.MD, width: imageSize ? 330 : null, height: imageSize ? 364 : null, resizeMode: imageSize && ResizeModeToken.CONTAIN }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    item['label'] ? (React.createElement(Typography, { label: item['label'].length > 6
                            ? item['label'].substring(0, 8) + '..'
                            : item['label'].substring(0, 4) + '..', fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, numberOfLines: 1 })) : null,
                    React.createElement(Space, { size: SizeTypeTokens.XXL }))),
            imageSize ? React.createElement(Space, { size: SizeTypeTokens.XXXL }) : null)));
    const iFrameItem = ({ item, index, }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Pressable, { style: {
                    flexDirection: 'row',
                    justifyContent: 'center',
                }, onPress: () => handleAction(item['label']) },
                React.createElement(View, { style: { flexDirection: 'column', width: 304 } },
                    React.createElement("iframe", { width: "304", height: "194", src: item["videoUrl"], style: {
                            borderRadius: 10
                        }, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", allowFullScreen: true }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Typography, { label: item['label'], fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 24, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Space, { size: SizeTypeTokens.MD })),
                React.createElement(Space, { size: SizeTypeTokens.XXXL }))));
    };
    const renderDashboardItem = ({ item, index }) => {
        return (React.createElement(View, { key: index },
            React.createElement(Pressable, { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingVertical: isMobile ? 9 : 22,
                    paddingHorizontal: isMobile ? 5 : 9,
                    width: isMobile ? 98 : 160,
                    height: isMobile ? 114 : 144,
                    borderRadius: 8,
                    elevation: 5,
                    shadowColor: 'rgba(9, 30, 66, 0.2)',
                    shadowOffset: {
                        width: 0,
                        height: 2,
                    },
                    shadowOpacity: 1,
                    shadowRadius: 5,
                    marginRight: isMobile ? 16 : 24,
                }, onPress: () => handleDashboardAction(index) },
                item && item?.icon && React.createElement(Icon, { name: item?.icon?.name, size: item?.icon?.size }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                item &&
                    item?.name &&
                    item?.name === 'FREE eligibility check in 15s' ? (React.createElement(React.Fragment, null,
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontWeight: '400',
                            fontSize: isMobile ? 12 : 16,
                            textAlign: 'center',
                        } },
                        React.createElement(Text, { style: { fontWeight: '600' } }, `FREE `),
                        React.createElement(Text, null, `eligibility check in 15s`)))) :
                    (React.createElement(Typography, { label: item?.name, fontWeight: "400", fontSize: isMobile ? FontSizeTokens.XS : FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, textAlign: TextAlignTokens.center })))));
    };
    const verticalRenderItem = ({ item }) => (React.createElement(Pressable, { style: {
            flexDirection: 'row',
        }, onPress: () => handleAction(item['label']) },
        React.createElement(View, { style: {
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
            } }, isIFrame ? (React.createElement(View, { style: { flexDirection: 'column' } },
            React.createElement(Typography, { label: item['label'], fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 24, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(WebView, { source: { uri: item["videoUrl"] }, allowsFullscreenVideo: true, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", style: { width: 304, height: 194, elevation: 0, borderRadius: 10, borderColor: isFromAndroidWebview() && '#000000', borderBottomColor: 'black' } }),
            React.createElement(Space, { size: SizeTypeTokens.XXL }))) : (React.createElement(React.Fragment, null,
            React.createElement(Image, { uri: item['image'], defaultUri: item['defaultUri'], size: ImageSizeTokens.SM, width: imageSize ? 330 : null, height: imageSize ? 364 : null, resizeMode: imageSize && ResizeModeToken.CONTAIN }),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            item['label'] ? (React.createElement(Typography, { label: item['label'], fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night })) : null))),
        React.createElement(Space, { size: SizeTypeTokens.LG })));
    const [searchText, setSearchText] = useState('');
    if (dashboardMenuItems &&
        type === GridItemTypeTokens.DASHBOARD_ITEM) {
        return (React.createElement(View, { style: {
                flex: 1,
                justifyContent: 'center',
                width: '100%',
            } },
            React.createElement(FlatList, { key: '_', contentContainerStyle: {
                    alignSelf: 'flex-start',
                }, data: dashboardMenuItems, numColumns: noOfCols, ItemSeparatorComponent: (item, index) => (index === 0 ? null : React.createElement(View, { style: { height: isMobile ? 16 : 24 } })), renderItem: renderDashboardItem, keyExtractor: (item, index) => index.toString() })));
    }
    if (data.length === 0)
        return React.createElement(React.Fragment, null);
    return (React.createElement(View, { style: {
            flex: 1,
            justifyContent: 'center',
            width: '100%',
        } },
        imageSize ? null : React.createElement(Space, { size: SizeTypeTokens.XXXL }),
        title ? (React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night })) : null,
        React.createElement(Space, { size: SizeTypeTokens.XL }),
        type === 'horizontal' ? (React.createElement(FlatList, { key: '_', contentContainerStyle: {
                alignSelf: 'flex-start',
            }, data: data, numColumns: numColumnsX, ItemSeparatorComponent: (item, index) => (index === 0 ? null : React.createElement(Space, { size: SizeTypeTokens.LG })), renderItem: horizontalRenderItem, keyExtractor: (item, index) => index.toString() })) : type === 'horizontal_vertical' ? (React.createElement(FlatList, { key: '$', contentContainerStyle: {
                alignSelf: 'flex-start',
            }, data: data, numColumns: numColumnsX, ItemSeparatorComponent: () => imageSize ? (React.createElement(Space, { size: SizeTypeTokens.LG })) : null, renderItem: horizontalRenderItem, keyExtractor: (item, index) => index.toString() })) : type === 'iFrame' ? (React.createElement(FlatList, { key: '$', contentContainerStyle: {
                alignSelf: 'flex-start',
            }, data: data, numColumns: noOfCols ? noOfCols : numColumnsX, ItemSeparatorComponent: () => (React.createElement(Space, { size: SizeTypeTokens.LG })), renderItem: iFrameItem, keyExtractor: (item, index) => index.toString() })) : (React.createElement(FlatList, { key: '#', contentContainerStyle: {
                alignSelf: 'flex-start',
            }, data: data, ItemSeparatorComponent: () => (React.createElement(Space, { size: SizeTypeTokens.LG })), numColumns: 1, renderItem: verticalRenderItem, keyExtractor: (item, index) => index.toString() })),
        other && other !== '' ? (React.createElement(React.Fragment, null,
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(Typography, { label: other, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night }),
            React.createElement(Space, { size: SizeTypeTokens.XXL }))) : null,
        otherItem ? (React.createElement(FlatList, { data: otherItem, style: {
                paddingVertical: 10,
            }, ItemSeparatorComponent: () => (React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.LG }, color: ColorTokens.White_20 })), renderItem: ({ item }) => (React.createElement(Pressable, { nativeID: id + '_' + item.label, onPress: () => handleAction(item['label']), style: {
                    flexDirection: 'row',
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        alignSelf: 'center',
                    } },
                    React.createElement(Image, { uri: item['image'], defaultUri: item['defaultUri'], size: ImageSizeTokens.SM }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Typography, { label: item['label'], fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night })),
                React.createElement(Space, { size: SizeTypeTokens.LG }))), keyExtractor: (item, index) => index.toString() })) : (React.createElement(React.Fragment, null))));
};
const styles = StyleSheet.create({
    webView: {
        ...Platform.OS === "android" && ({
            elevation: 0,
            borderRadius: 10,
            overflow: 'hidden',
            borderColor: 'transparent',
        }),
    },
});
export default memo(GridListItem);
export { GridListItem };
